module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-36.3ce32e46.png";